import { render, staticRenderFns } from "./TaskStatusList.vue?vue&type=template&id=e8c74114&scoped=true&"
import script from "./TaskStatusList.vue?vue&type=script&lang=js&"
export * from "./TaskStatusList.vue?vue&type=script&lang=js&"
import style0 from "./TaskStatusList.vue?vue&type=style&index=0&id=e8c74114&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c74114",
  null
  
)

export default component.exports